/**
* gplans Intercom
* @namespace gplans.intercom
*/
(function (angular) {
  'use strict';

  angular.
  module('gplans.intercom').
  factory('Intercom', Intercom);

  Intercom.$inject = ['$window', 'IntercomConfiguration'];

  /**
                                                           * @namespace gplans.intercom
                                                           */Intercom.$inject = ["$window", "IntercomConfiguration"];
  function Intercom($window, IntercomConfiguration) {
    /**
                                                     * @name Intercom
                                                     * @desc The factory to be returned
                                                     */
    var Intercom = {
      bootOrUpdate: bootOrUpdate,
      afterIntercomMessengerBooted: afterIntercomMessengerBooted };


    return Intercom;

    ////////////////////

    /**
    * @name bootOrUpdate
    * @desc boot Intercom or update user object if we're booted already
    * @param {Object} userData object
    * @memberOf gplans.intercom
    */
    function bootOrUpdate(userData) {
      var props = {
        user_id: userData.intercom_id,
        app_id: IntercomConfiguration.APP_ID,
        user_hash: userData.intercom_user_hash };

      if (userData.age) props.age = userData.age;
      if (userData.uid) props.uid = userData.uid;
      if (userData.username) props.username = userData.username;
      if (userData.gender) props.gender = userData.gender;
      if (userData.email) props.email = userData.email;
      props.name = '';
      if (userData.first_name) props.name += userData.first_name;
      if (props.name && userData.last_name) props.name += ' ';
      if (userData.last_name) props.name += userData.last_name;
      if (userData.date_joined) props.created_at = Math.round(new Date(userData.date_joined).getTime() / 1000);
      if (userData.subscription_plan && userData.subscription_plan.name) {
        props.plan = userData.subscription_plan.name;
        props.subscription_status = 'active';
      } else
      if (!userData.subscription_plan || userData.subscription_plan && !userData.subscription_plan.name) {
        props.plan = '';
        props.subscription_status = 'not active';
      }
      if (userData.payment_method) props.payment_method = userData.payment_method;
      if (userData.setmore_customer_key) props.managed_plan = true;
      props.redesign = true;

      if ($window.Intercom && !$window.Intercom.booted) {
        $window.Intercom('boot', props);
      } else if ($window.Intercom) {
        $window.Intercom('update', props);
      }
    }

    // TODO: add jsdoc, refactor with $timeout, $interval
    function afterIntercomMessengerBooted(cb) {
      if (angular.isFunction(cb)) {
        var timeout;
        var interval = setInterval(function () {
          // var el = document.getElementById('intercom-container');
          var el = document.querySelector('.intercom-launcher');
          if ($window.Intercom && $window.Intercom.booted && el) {
            cb(el);
            clearInterval(interval);
            clearTimeout(timeout);
          }
        }, 100);

        timeout = setTimeout(function () {
          clearInterval(interval);
        }, 10000);
      }
    }
  }
})(angular);